export enum FindByTypes
{
    OrderNumber = 1,
    TripNumber,
    PatientName,
    DriverName,
    OrderReference,
    DeliveryNumber
}

export enum SortByTypes {
    OrderStatus = 1,
    OrderNumber,
    OrderDate,
    PatientName,
    ReferenceNumber,
    TripStatus,
    TripNumber,
    Driver,
    SpecialInstructions,
    DispatchedBy,
    DispatchDate,
    DeliveryStatus
}